var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.98 25.6486C103.858 24.53 103.163 23.5399 102.124 23.0551L53.3741 0.305084C52.5029 -0.101369 51.4967 -0.101369 50.6255 0.305084L1.87545 23.0551C0.836672 23.5399 0.141578 24.5298 0.0199062 25.6486C0.0172656 25.6719 0 25.9831 0 26.0002V81.2502C0 82.579 0.809047 83.7742 2.04303 84.2676L50.793 103.768C51.1804 103.923 51.5903 104 52 104C52.4097 104 52.8196 103.923 53.207 103.768L101.957 84.2676C103.191 83.7742 104 82.579 104 81.2502V26.0002C104 25.9831 103.982 25.6717 103.98 25.6486ZM52 6.83657L92.573 25.7707L76.9498 32.02L35.6133 14.4838L52 6.83657ZM27.688 18.1823L68.3833 35.4465L52 41.9997L11.427 25.7707L27.688 18.1823ZM6.5 30.8004L48.75 47.7004V95.9498L6.5 79.0497V30.8004ZM55.25 95.95V47.7004L97.5 30.8004V79.0497L55.25 95.95Z",
    fill: "#68AC82"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.2b71cf6559e5efafe29d2b8570d75030.svg";
export { ForwardRef as ReactComponent };